import { AppProviders, configureAppErrorReporting } from "@how/app-kit";
import { RouterProvider } from "react-router";
import { env } from "../lib/env";
import { queryClient } from "../lib/query-client";
import { supabase } from "../lib/supabase";
import { createAppRouter } from "./router";

// This app's one error destination (ADR 0038), set before the first render so an early failure is reported too.
configureAppErrorReporting({
  surface: "control_plane",
  supabaseUrl: env.VITE_SUPABASE_URL,
  client: supabase,
});

const router = createAppRouter();

/** Provider stack from @how/app-kit plus the control plane's router. */
export function App() {
  return (
    <AppProviders client={supabase} queryClient={queryClient}>
      <RouterProvider router={router} />
    </AppProviders>
  );
}
